import React, { useEffect, useState } from "react";
import { getOrderEdits } from "../Logic";

const when = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
};

const rupees = (value) => `₹${Number(value || 0).toFixed(2)}`;

function OrderEditHistory({ orderId }) {
  const [edits, setEdits] = useState([]);

  useEffect(() => {
    if (!orderId) return;
    getOrderEdits(orderId)
      .then((result) => setEdits(Array.isArray(result?.data?.edits) ? result.data.edits : []))
      .catch(() => setEdits([]));
  }, [orderId]);

  if (edits.length === 0) return null;

  return (
    <div className="col-xl-12 col-sm-6">
      <div className="card">
        <div className="card-header border-0 pb-0">
          <h4 className="fs-20 font-w600">Edit history</h4>
        </div>
        <div className="card-body pb-2">
          {edits.map((edit, index) => (
            <div key={`${edit.edited_at}-${index}`} className="mb-3" data-testid="order-edit">
              <p className="mb-1 text-black font-w600">
                {when(edit.edited_at)}
                {edit.edited_by ? ` · by ${edit.edited_by}` : ""}
              </p>
              <p className="mb-1">
                Total {rupees(edit.net_before)} → {rupees(edit.net_after)}
              </p>
              {edit.changes.map((line) => (
                <p key={line} className="mb-0 fs-14">
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OrderEditHistory;
